import {AbstractApp} from "@variocube/app-common";
import {Language, Platform} from "@variocube/app-api";
import * as React from "react";
import icon from "./icon.svg";
import {stylesheet} from "typestyle";
import {render} from "react-dom";

export default class YouCubeApp /* (pun intended) */
    extends AbstractApp {

    constructor(platform: Platform) {
        super(platform, icon, "#ff0000", [Language.EN]);
        this.name = "YouTube";
        this.description = "Watch your favorite video";
        this.updateLauncherItems();
    }

    render(root: Element) {
        render(<HomeScreen/>, root);
    }
}

function HomeScreen() {
    return (
        <div className={styles.container}>
            <div className={styles.video} style={{width: "560px"}}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/7aUATjq2zfk?start=59"
                        frameBorder="0" allowFullScreen/>
            </div>
            <div className={styles.noOtherVidsMessage}>
                Unfortunately there are no other videos available at the moment. Somebody needs to implement search.
            </div>
        </div>
    );
}

const styles = stylesheet({
    container: {
        position: "relative",
    },
    video: {
        margin: "2em auto 1.5em auto"
    },
    noOtherVidsMessage: {
        margin: "1.5em 0",
        color: "#666",
        fontSize: "0.75em",
        textAlign: "center",
    }
});